const state = {
  error: {},
  success: {},
  warning: {},
  info: {},
};

export default state;
